import { useNavigate } from "react-router-dom";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Source+Serif+4:wght@500;600;700&display=swap');

  * { box-sizing: border-box; margin: 0; padding: 0; }

  body {
    background: #fcfbf8;
    color: #111111;
    font-family: 'Inter', sans-serif;
    min-height: 100vh;
  }

  .page {
    max-width: 980px;
    margin: 0 auto;
    padding: 40px 24px 96px;
  }

  .nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 72px;
  }

  .brand,
  .back-link {
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #111111;
    text-decoration: none;
    background: none;
    border: none;
    cursor: pointer;
    font-family: 'Inter', sans-serif;
  }

  .brand {
    font-weight: 600;
  }

  .hero {
    padding-bottom: 56px;
    border-bottom: 1px solid #e7e7e7;
    margin-bottom: 56px;
  }

  .eyebrow {
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #5f5f5f;
    margin-bottom: 18px;
  }

  .title {
    font-family: 'Source Serif 4', serif;
    font-size: clamp(42px, 7vw, 72px);
    line-height: 0.98;
    letter-spacing: -0.03em;
    color: #1f3b63;
    max-width: 760px;
    margin-bottom: 20px;
  }

  .intro {
    font-size: 18px;
    line-height: 1.75;
    color: #444444;
    max-width: 700px;
  }

  .section {
    padding: 48px 0;
    border-bottom: 1px solid #e7e7e7;
  }

  .section-grid {
    display: grid;
    grid-template-columns: 220px 1fr;
    gap: 32px;
    align-items: start;
  }

  .section-label {
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #6a6a6a;
    padding-top: 6px;
  }

  .section-title {
    font-family: 'Source Serif 4', serif;
    font-size: 34px;
    line-height: 1.15;
    letter-spacing: -0.02em;
    color: #1f3b63;
    margin-bottom: 14px;
  }

  .section-intro {
    font-size: 16px;
    line-height: 1.75;
    color: #4a4a4a;
    max-width: 720px;
    margin-bottom: 28px;
  }

  .process-list {
    display: grid;
    gap: 18px;
    margin-top: 8px;
  }

  .process-item {
    display: grid;
    grid-template-columns: 44px 1fr;
    gap: 18px;
    padding: 20px 0;
    border-top: 1px solid #eeeeee;
  }

  .process-item:last-child {
    border-bottom: 1px solid #eeeeee;
  }

  .process-num {
    font-family: 'Source Serif 4', serif;
    font-size: 24px;
    line-height: 1;
    color: #1d4ed8;
    padding-top: 2px;
  }

  .item-title {
    font-size: 16px;
    font-weight: 600;
    color: #1f3b63;
    margin-bottom: 6px;
  }

  .item-text {
    font-size: 15px;
    line-height: 1.7;
    color: #4b4b4b;
    max-width: 700px;
  }

  .outcomes {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 18px 28px;
    margin-top: 12px;
  }

  .outcome {
    padding: 18px 0;
    border-top: 1px solid #eeeeee;
  }

  .outcome-title {
    font-size: 15px;
    font-weight: 600;
    color: #1f3b63;
    margin-bottom: 6px;
  }

  .outcome-text {
    font-size: 15px;
    line-height: 1.7;
    color: #4b4b4b;
  }

  .note-list {
    display: grid;
    gap: 14px;
    margin-top: 10px;
  }

  .note {
    padding: 16px 18px;
    border: 1px solid #ebebeb;
    border-radius: 10px;
    font-size: 15px;
    line-height: 1.7;
    color: #444444;
    background: #fcfcfc;
  }

  .cta {
    padding-top: 56px;
  }

  .cta-box {
    border: 1px solid #e7e7e7;
    border-radius: 16px;
    padding: 36px;
    background: #f6f8fc;
  }

  .cta-title {
    font-family: 'Source Serif 4', serif;
    font-size: 34px;
    line-height: 1.15;
    letter-spacing: -0.02em;
    color: #1f3b63;
    margin-bottom: 12px;
  }

  .cta-text {
    font-size: 16px;
    line-height: 1.75;
    color: #4b4b4b;
    max-width: 640px;
    margin-bottom: 24px;
  }

  .cta-btn {
    appearance: none;
    border: none;
    background: #1f3b63;
    color: #ffffff;
    padding: 14px 22px;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    cursor: pointer;
    transition: opacity 0.2s ease;
  }

  .cta-btn:hover {
    opacity: 0.88;
  }

  @media (max-width: 820px) {
    .section-grid {
      grid-template-columns: 1fr;
      gap: 18px;
    }

    .outcomes {
      grid-template-columns: 1fr;
    }

    .nav {
      margin-bottom: 56px;
    }

    .hero {
      padding-bottom: 44px;
      margin-bottom: 44px;
    }
  }

  @media (max-width: 560px) {
    .page {
      padding: 28px 18px 72px;
    }

    .title {
      font-size: 42px;
    }

    .intro {
      font-size: 16px;
    }

    .section {
      padding: 36px 0;
    }

    .section-title,
    .cta-title {
      font-size: 28px;
    }

    .cta-box {
      padding: 24px;
      border-radius: 14px;
    }
  }
`;

export default function HowItWorks() {
  const navigate = useNavigate();

  return (
    <>
      <style>{styles}</style>

      <div className="page">
        <div className="nav">
          <button className="brand" onClick={() => navigate("/")}>
            NewsDepth
          </button>
          <button className="back-link" onClick={() => navigate("/")}>
            Back to home
          </button>
        </div>

        <section className="hero">
          <div className="eyebrow">How it works</div>
          <h1 className="title">Understand a story beyond a single article.</h1>
          <p className="intro">
            NewsDepth helps readers make sense of a news story by combining one
            article with broader coverage. It summarises what happened, shows how
            other outlets reported the same event, and surfaces context or
            uncertainty that may matter.
          </p>
        </section>

        <section className="section">
          <div className="section-grid">
            <div className="section-label">Process</div>
            <div>
              <h2 className="section-title">From one link to a broader view</h2>
              <p className="section-intro">
                When you paste an article URL, NewsDepth follows a simple
                pipeline designed to help you understand the story rather than
                score the writing.
              </p>

              <div className="process-list">
                <div className="process-item">
                  <div className="process-num">1</div>
                  <div>
                    <div className="item-title">Extract the article</div>
                    <div className="item-text">
                      The article text is fetched and cleaned so the analysis is
                      based on the reporting itself rather than page clutter.
                    </div>
                  </div>
                </div>

                <div className="process-item">
                  <div className="process-num">2</div>
                  <div>
                    <div className="item-title">Identify the core story</div>
                    <div className="item-text">
                      The system summarises what happened and pulls out the main
                      claims and themes in the article.
                    </div>
                  </div>
                </div>

                <div className="process-item">
                  <div className="process-num">3</div>
                  <div>
                    <div className="item-title">Compare related coverage</div>
                    <div className="item-text">
                      NewsDepth looks for other reporting on the same event and
                      compares what different outlets include, emphasise, or leave out.
                    </div>
                  </div>
                </div>

                <div className="process-item">
                  <div className="process-num">4</div>
                  <div>
                    <div className="item-title">Surface context and uncertainty</div>
                    <div className="item-text">
                      The final output highlights useful background, open
                      questions, and points that may still be unclear or developing.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-grid">
            <div className="section-label">What you get</div>
            <div>
              <h2 className="section-title">A cleaner way to read the news</h2>
              <p className="section-intro">
                Each analysis is designed to help you move quickly from one
                article to a more informed understanding of the story.
              </p>

              <div className="outcomes">
                <div className="outcome">
                  <div className="outcome-title">What happened</div>
                  <div className="outcome-text">
                    A concise summary of the story in plain language.
                  </div>
                </div>

                <div className="outcome">
                  <div className="outcome-title">What this article says</div>
                  <div className="outcome-text">
                    The main claims and takeaways presented in the article itself.
                  </div>
                </div>

                <div className="outcome">
                  <div className="outcome-title">How others covered it</div>
                  <div className="outcome-text">
                    Links to related reporting so you can compare sources directly.
                  </div>
                </div>

                <div className="outcome">
                  <div className="outcome-title">Where coverage differs</div>
                  <div className="outcome-text">
                    Meaningful differences in emphasis, detail, and reporting.
                  </div>
                </div>

                <div className="outcome">
                  <div className="outcome-title">Missing context</div>
                  <div className="outcome-text">
                    Background or perspectives that may not appear in the original article.
                  </div>
                </div>

                <div className="outcome">
                  <div className="outcome-title">What remains unclear</div>
                  <div className="outcome-text">
                    Unresolved points, uncertainty, and useful follow-up questions.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-grid">
            <div className="section-label">Limitations</div>
            <div>
              <h2 className="section-title">Useful, but not definitive</h2>
              <p className="section-intro">
                NewsDepth is designed to support understanding, not replace
                judgement. It helps compare reporting, but it does not determine
                absolute truth.
              </p>

              <div className="note-list">
                <div className="note">
                  It cannot independently verify every fact in an article.
                </div>
                <div className="note">
                  AI summaries and comparisons may miss nuance or make mistakes.
                </div>
                <div className="note">
                  Fast-moving stories can change quickly, and differences between
                  reports may reflect timing rather than error.
                </div>
                <div className="note">
                  Some websites block article extraction or provide incomplete text.
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-grid">
            <div className="section-label">Privacy</div>
            <div>
              <h2 className="section-title">Designed to be lightweight</h2>
              <p className="section-intro">
                NewsDepth does not require an account. Shared analyses are stored
                temporarily, and article text is processed only to generate the result.
              </p>

              <div className="note-list">
                <div className="note">No account or login is required.</div>
                <div className="note">
                  Shared analyses are stored for a limited time and then deleted.
                </div>
                <div className="note">
                  Article text is processed by AI services to generate summaries and comparisons.
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="cta">
          <div className="cta-box">
            <h2 className="cta-title">Ready to try it?</h2>
            <p className="cta-text">
              Paste a news article URL and explore the broader story around it.
            </p>
            <button className="cta-btn" onClick={() => navigate("/")}>
              Analyse an article
            </button>
          </div>
        </section>
      </div>
    </>
  );
}